import React from "react";
import { useHistory } from "react-router-dom";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
  faLayerGroup, 
  faCalendar, 
  faEdit
} from "@fortawesome/free-solid-svg-icons";
import Button from "components/CustomButton";
import { truncateText } from "utils/helpers";

const GrowthPartnerCourseCard = ({ course, teamId }) => {
  const history = useHistory();

  // Handle reviewing a course
  const handleReviewCourse = (courseId) => {
    // Get the course owner ID from the course data
    const courseOwnerId = course.course_owner?.id;
    
    // Navigate directly to the course view page - the UserCourseView component will fetch the course data
    const url = courseOwnerId 
      ? `/teams/${teamId}/growth-partner-courses/${courseId}/view?user_id=${courseOwnerId}`
      : `/teams/${teamId}/growth-partner-courses/${courseId}/view`;
    history.push(url);
  };

  return (
    <div className="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-6 mb-4">
      <div className="card h-100 d-flex flex-column course-list-card">
        <div className="course-card-cover position-relative" style={{
          height: '180px', 
          background: '#f5f5f5', 
          borderTopLeftRadius: '6px', 
          borderTopRightRadius: '6px', 
          overflow: 'hidden',
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center'
        }}>
          {course.thumbnail ? (
            <img 
              src={course.thumbnail} 
              alt={course.title} 
              style={{width: '100%', height: '100%', objectFit: 'cover'}}
            />
          ) : (
            <img 
              src="https://images.pexels.com/photos/4050315/pexels-photo-4050315.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2" 
              alt="Course Cover" 
              style={{width: '100%', height: '100%', objectFit: 'cover'}}
            />
          )}
          <span className="course-status-pill badge bg-primary position-absolute top-0 end-0 m-2">Growth Partner</span>
        </div>
        
        <div className="card-body flex-grow-1 d-flex flex-column">
          <h5 className="card-title mb-1 text-truncate"><strong>{course.title}</strong></h5>
          <p className="card-text text-muted mb-2">{truncateText(course.description, 200)}</p>
          
          <div className="d-flex align-items-center mb-2 gap-3">
            <span className="d-flex align-items-center">
              <FontAwesomeIcon icon={faLayerGroup} className="me-1 text-primary" />
              <small className="text-muted">
                {course.modules?.length || 0} {course.modules?.length === 1 ? 'module' : 'modules'}
              </small>
            </span>
            <span className="d-flex align-items-center">
              <FontAwesomeIcon icon={faCalendar} className="me-1 text-secondary" />
              <small className="text-muted">
                {course.createdAt ? moment(course.createdAt).format("MMM DD, YYYY") : ''}
              </small>
            </span>
          </div>
          
          <div className="d-flex align-items-center mt-auto gap-2">                          
            <Button 
              buttonClass="btn btn-primary ms-auto w-100"
              onClick={() => handleReviewCourse(course.id)}
            >
              <FontAwesomeIcon icon={faEdit} className="me-2" />
              Review
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GrowthPartnerCourseCard; 